import { useNavigate } from 'react-router-dom';
import { getCurrentSubscription } from '../../api/subscription';
import ThanksBanner1 from '../../assets/ThanksBanner1.png';
import ThanksBanner2 from '../../assets/ThanksBanner2.png';
import { getRetailerCurrentSubscription } from '../../api/RetailerSubscription';

const ThankYou = () => {
  const navigate = useNavigate();

  const setting = sessionStorage.getItem('setting');

  const shopId = sessionStorage.getItem('shopId');

  const businessType = sessionStorage.getItem('businessType');

  const getSubscriptionDetail = async () => {
    const response =
      businessType === 'Retail'
        ? await getRetailerCurrentSubscription(shopId)
        : await getCurrentSubscription();

    if (response && response.payload) {
      sessionStorage.removeItem('planDetail');

      sessionStorage.setItem('planDetail', JSON.stringify(response.payload.plan));

      if (response.payload.plan && response.payload.plan.data.analytics) {
        if (setting === 'finished') {
          navigate('/settings/subscription');
        } else {
          navigate('/account-setup/create-profile');
        }
      }
    }
  };

  return (
    <div className="flex h-full flex-col">
      <div>
        <img src={ThanksBanner1} className="w-[220px]" />
      </div>

      <div className="flex justify-center items-center flex-col">
        <label className="text-[50px] text-white font-bold">Thank You</label>

        <label className="text-[22px] text-white mb-5">Enjoy all the features and benefits</label>

        <button
          type="button"
          className="bg-[#006BEA] text-white font-medium text-base px-3 py-1 rounded"
          onClick={getSubscriptionDetail}
        >
          {setting === 'finished' ? 'Back to Setings' : 'Navigate to setup'}
        </button>
      </div>

      <div className="flex justify-end">
        <img src={ThanksBanner2} className="w-[220px]" />
      </div>
    </div>
  );
};

export default ThankYou;
